<template>
  <div>
    <img :src="src" @click="previewImg" class="cursor img" :style="imgStyle()" >
    <el-dialog
      v-model="dialogVisible"
      title="预览图片"
      width="50%"
      append-to-body
    >
      <ZPreview :authSrc="authSrc" height="300px" width="100%" :showPreview="false"/>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            type="danger"
            @click="dialogVisible = false"
            >关闭</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script lang='ts'>
import { defineComponent, ref, watch, nextTick, reactive, toRefs, inject, onMounted } from 'vue'
// import { getToken } from '@/utils/cookies'

export default defineComponent({
  name: 'ZPreview',
  props: {
    authSrc: { type: String, default: '', required: true },
    width: { type: String, default: '178px', required: false },
    height: { type: String, default: '178px', required: false },
    showPreview: { type: Boolean, default: true, required: false }
  },
  setup(props) {
    const headers = {
      'X-APP-ID': 'WEB'
    }
    const $api = inject('$api') as string
    const baseUrl = $api
    const data = reactive({
      src: '',
      dialogVisible: false
    })
    const imgStyle = () => {
      return `width:${props.width};height:${props.height}`
    }
    const loadImgSrc = () => {
      if (!props.authSrc) {
        data.src = ''
        return
      }

      let fullUrl = props.authSrc
      if (!fullUrl.startsWith('http')) {
        fullUrl = (baseUrl.endsWith('/') ? baseUrl : baseUrl + '/') + (props.authSrc.startsWith('/') ? props.authSrc.substring(1) : props.authSrc)
      }

      const request = new XMLHttpRequest()
      request.responseType = 'blob'
      request.open('get', fullUrl, true)
      request.withCredentials = true // 确保发送 Cookies

      request.setRequestHeader('X-APP-ID', headers['X-APP-ID'])

      request.onload = () => {
        if (request.status === 200) {
          const blob = request.response
          const oFileReader = new FileReader()
          oFileReader.onloadend = function(e: any) {
            const base64 = e.target.result
            data.src = base64 as string
          }
          oFileReader.readAsDataURL(blob)
        } else {
          console.error(`Failed to load image: ${fullUrl}, status: ${request.status}`)
        }
      }
      request.onerror = () => {
        console.error(`XHR error loading image: ${fullUrl}`)
      }
      request.send(null)
    }
    const previewImg = () => {
      if (!props.showPreview) {
        return false
      }
      data.dialogVisible = true
    }

    watch(() => props.authSrc, () => {
      loadImgSrc()
    })
    onMounted(() => {
      loadImgSrc()
    })
    return { imgStyle, previewImg, ...toRefs(data) }
  }

})
</script>
<style  lang="scss" scope>
.img{
  margin: 0 auto;
  display: block;
  width: 178px;
  height: 178px;
  object-fit: contain;
  overflow: hidden;
  border-radius: 2px;
}
.previewBtn{
  color:$light-blue;
}
</style>
